import { createClient } from 'contentful';
import offlineClient from './offlineContentfulClient';

// Check if we're in offline mode (set by index.html or manually)
const isOfflineMode = window.OFFLINE_MODE === true;

let client;

if (isOfflineMode) {
  console.log('Using offline Contentful client');
  client = offlineClient;
} else {
  console.log('Using online Contentful client');
  client = createClient({
    space: process.env.REACT_APP_SPACE_ID,
    accessToken: process.env.REACT_APP_ACCESS_TOKEN,
  });
}

export default client;